import React from 'react';
import PropTypes from 'prop-types';

import SlideshowModal from 'components/SlideshowModal';

import { HowItWorksCard1, HowItWorksCard2, HowItWorksCard3 } from './HowItWorks';

function CampaignsModal({ closeModal }) {
  return (
    <SlideshowModal onClose={closeModal}>
      <HowItWorksCard1 />
      <HowItWorksCard2 />
      <HowItWorksCard3 />
    </SlideshowModal>
  );
}

CampaignsModal.propTypes = {
  closeModal: PropTypes.func,
};

export default CampaignsModal;
